import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { NgIf, NgFor } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

export interface ValidationFailureData {
  missingFields: { row: number; fields: string[] }[];
  invalidMasterData: {
    branches: string[];
    departments: string[];
    designations: string[];
  };
  duplicateEmployeeCodes?: { row: number; code: string }[];
  duplicateEmails?: { row: number; email: string }[];
  templateErrors?: string[];
}

@Component({
  selector: 'app-validation-failure-dialog',
  templateUrl: './validation-failure-dialog.component.html',
  styleUrls: ['./validation-failure-dialog.component.scss'],
  imports: [NgIf, NgFor, MatDialogContent, MatDialogActions, MatButton, MatIcon, MatIconButton]
})
export class ValidationFailureDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ValidationFailureDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ValidationFailureData
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  get hasMissingFields(): boolean {
    return this.data.missingFields && this.data.missingFields.length > 0;
  }

  get hasInvalidMasterData(): boolean {
    return (
      (this.data.invalidMasterData?.branches?.length ?? 0) > 0 ||
      (this.data.invalidMasterData?.departments?.length ?? 0) > 0 ||
      (this.data.invalidMasterData?.designations?.length ?? 0) > 0
    );
  }

  get hasDuplicateErrors(): boolean {
    return (this.data.duplicateEmployeeCodes?.length ?? 0) > 0 || (this.data.duplicateEmails?.length ?? 0) > 0;
  }


  get hasTemplateErrors(): boolean {
    return (this.data.templateErrors?.length ?? 0) > 0;
  }
}
